import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Snackbar,
  Tooltip,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  useMaterialReactTable,
  MaterialReactTable,
} from "material-react-table";
import Header from "../../component/Header";
import {
  fetchCodesAction,
  deleteCodeAction,
  updateRowOrderAction,
} from "../../state/promoCode/promoCodeSlice";
import AddCodeForm from "./addCode";
import EditCode from "./editCode";

const PromoCodes = () => {
  const dispatch = useDispatch();

  const [dataSource, setDataSource] = useState([]);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [promoCodeToDelete, setPromoCodeToDelete] = useState(null);
  const [toastMessage, setToastMessage] = useState("");
  const [openToast, setOpenToast] = useState(false);

  const [openDrawer, setOpenDrawer] = useState(false);
  const [openEditDrawer, setOpenEditDrawer] = useState(false);
  const [editId, setEditId] = useState(null);

  const promoCodes = useSelector((state) => state.promoCode.Details);

  useEffect(() => {
    dispatch(fetchCodesAction());
  }, [dispatch]);

  useEffect(() => {
    if (promoCodes) {
      const data = promoCodes.map((item) => ({ ...item, id: item.id }));
      setDataSource(data);
    }
  }, [promoCodes]);
  const openHandler = () => {
    setOpenDrawer((o) => !o);
  };
  const openEditHandler = () => {
    setOpenEditDrawer((o) => !o);
  };

  const handleDeletePromoCode = async () => {
    if (promoCodeToDelete) {
      await dispatch(deleteCodeAction(promoCodeToDelete));
      setDeleteConfirmationOpen(false);
      await dispatch(fetchCodesAction());
      setToastMessage("Promo code deleted successfully");
      setOpenToast(true);
    }
  };

  const handleConfirmDelete = (promoCodeId) => {
    setPromoCodeToDelete(promoCodeId);
    setDeleteConfirmationOpen(true);
  };

  const handleCloseDeleteConfirmation = () => {
    setPromoCodeToDelete(null);
    setDeleteConfirmationOpen(false);
  };
  const handleRowOrderChange = (newData) => {
    // Dispatch the action to update the row order
    dispatch(updateRowOrderAction(newData))
      .then(() => {
        // If the action was successful, update the local state
        setDataSource(newData);
        console.log(newData);
        dispatch(fetchCodesAction());
      })
      .catch((error) => {
        console.error("Error updating row order:", error);
        // Handle the error if necessary
        // You might want to show a toast message or handle the error in some other way
      });
  };

  const columns = [
    {
      accessorKey: "orderNumber",
      header: "ID",
      size: 50,
    },
    {
      accessorKey: "promoCode",
      header: "Code",
      size: 100,
    },
    {
      accessorKey: "startDate",
      header: "Start Date",
      size: 150,
    },
    {
      accessorKey: "expiryDate",
      header: "Expiry Date",
      size: 150,
    },
    {
      accessorKey: "discount",
      header: "Discount",
      size: 100,
    },
    {
      header: "Actions",
      Cell: ({ row }) => (
        <span>
          <Tooltip title="Delete">
            <IconButton
              color="error"
              onClick={() => handleConfirmDelete(row.original._id)}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Edit">
            <IconButton
              color="error"
              onClick={() => handleEditDetails(row.original._id)}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        </span>
      ),
    },
  ];
  const handleEditDetails = (id) => {
    openEditHandler(true);
    setEditId(id);
  };

  const handleToastClose = () => {
    setOpenToast(false);
  };

  const table = useMaterialReactTable({
    autoResetPageIndex: false,
    columns,
    data: dataSource,
    enableRowOrdering: true,
    enableSorting: true,
    muiRowDragHandleProps: ({ table }) => ({
      onDragEnd: () => {
        const { draggingRow, hoveredRow } = table.getState();
        if (hoveredRow && draggingRow) {
          const newData = [...dataSource];
          newData.splice(
            hoveredRow.index,
            0,
            newData.splice(draggingRow.index, 1)[0]
          );
          handleRowOrderChange(newData);
        }
      },
    }),
  });
  return (
    <>
      <EditCode
        handleClose={() => setOpenEditDrawer(false)}
        open={openEditDrawer}
        id={editId}
      />
      <AddCodeForm handleClose={() => setOpenDrawer(false)} open={openDrawer} />
      <Dialog
        open={deleteConfirmationOpen}
        onClose={handleCloseDeleteConfirmation}
        aria-labelledby="delete-confirmation-dialog-title"
      >
        <DialogTitle id="delete-confirmation-dialog-title">
          Confirm Delete
        </DialogTitle>
        <DialogContent>
          Are you sure you want to delete this allergen?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteConfirmation} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleDeletePromoCode} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={openToast}
        autoHideDuration={3000}
        onClose={handleToastClose}
        message={toastMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        key={"bottom-left"}
      />

      <Box m="1.5rem 2.5rem">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Header title="Promo Codes" subtitle="List of Promo Codes" />
          <Button
            variant="contained"
            onClick={openHandler}
            color="secondary"
            size="lg"
            startIcon={<AddCircleOutlineIcon />}
          >
            Add
          </Button>
        </div>

        <Box mt="40px" height="75vh">
          <MaterialReactTable table={table} />
        </Box>
      </Box>
    </>
  );
};

export default PromoCodes;
